import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { map } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { sortFn } from "../Utils.js";
import { Tickets_Severity_FromId_Z524259A4, Tickets_TicketStatus, Tickets_TicketType, Tickets_TicketStatus_FromId_Z524259A4, Tickets_TicketType_FromId_Z524259A4 } from "../Shared/Shared.js";
import { int32ToString, createObj, equals } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { map as map_1, getSubArray } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { onPageChange, headerSortCell } from "../ViewHelpers.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { TablePagination, TableContainer, TableBody, Link, TableHead, TableRow, Table, Checkbox, FormControlLabel, Typography, TableCell } from "@mui/material";
import { singleton, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { singleton as singleton_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { Tickets_SeverityChip_5E2CD6A8 } from "./Tickets/SeverityChip.js";
import { Tickets_StatusChip_Z17F2D702 } from "./Tickets/StatusChip.js";
import { RouterModule_encodeParts, RouterModule_nav } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";

export function Components_DeviationTicketsTable_334C27A3(components_DeviationTicketsTable_334C27A3InputProps) {
    let elems_2, elems, elems_1, children_3, elements_5, children, elements, children_2;
    const tickets = components_DeviationTicketsTable_334C27A3InputProps.tickets;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const onlyMine = patternInput[0];
    const patternInput_1 = reactApi.useState(false);
    const closed = patternInput_1[0];
    const patternInput_2 = reactApi.useState(true);
    const asc = patternInput_2[0];
    const patternInput_3 = reactApi.useState("PlannedDate");
    const sortKey = patternInput_3[0];
    const patternInput_4 = reactApi.useState(0);
    const setPage = patternInput_4[1];
    const page = patternInput_4[0] | 0;
    const patternInput_5 = reactApi.useState(5);
    const rowsPerPage = patternInput_5[0] | 0;
    const rowsPerPageOptions = new Int32Array([5, 10, 15, 20]);
    const accountIdOpt = map((sess) => sess.UserId, ctx.Session);
    const rowsToSkip = (page * rowsPerPage) | 0;
    let rowsToTake;
    const nextTakeCount = (rowsToSkip + rowsPerPage) | 0;
    rowsToTake = ((tickets.length < nextTakeCount) ? (tickets.length - rowsToSkip) : rowsPerPage);
    const sorted = sortFn(asc, sortKey)(tickets.filter((ticket) => {
        const type$0027 = Tickets_TicketType_FromId_Z524259A4(ticket.Type);
        const status = Tickets_TicketStatus_FromId_Z524259A4(ticket.Status);
        if ((equals(type$0027, new Tickets_TicketType(5, [])) ? true : equals(type$0027, new Tickets_TicketType(6, []))) && (closed ? true : !equals(status, new Tickets_TicketStatus(4, [])))) {
            if (!onlyMine) {
                return true;
            }
            else {
                return equals(ticket.Creator.AccountId, accountIdOpt);
            }
        }
        else {
            return false;
        }
    }));
    const currentRows = getSubArray(sorted, rowsToSkip, rowsToTake);
    const header = (key_1, label) => headerSortCell(sortKey, asc, (key) => {
        patternInput_3[1](key);
        patternInput_2[1]((key !== sortKey) ? true : !asc);
    }, key_1, label);
    const cell = (child) => MuiHelpers_createElement(TableCell, [["variant", "body"], ["children", createElement("div", {
        style: {
            display: "flex",
        },
        children: child,
    })]]);
    const xs_6 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 5 + "px ",
    }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
        flexGrow: 1,
    }], (elems = [MuiHelpers_createElement(Typography, [["variant", "h4"], ["children", ctx.Locale.t("OverviewDashboard.OpenNonconformities")]])], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "flex-end",
    }], (elems_1 = [MuiHelpers_createElement(FormControlLabel, [["label", ctx.Locale.t("TicketList.MyTicketsShort")], ["control", MuiHelpers_createElement(Checkbox, [["onChange", (e) => {
        patternInput[1](e.target.checked);
    }], ["checked", onlyMine]])]]), MuiHelpers_createElement(FormControlLabel, [["label", ctx.Locale.t("Ticket.Status.Closed")], ["control", MuiHelpers_createElement(Checkbox, [["color", "primary"], ["size", "small"], ["onChange", (e_1) => {
        patternInput_1[1](e_1.target.checked);
    }], ["checked", closed]])]])], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), (children_3 = singleton(MuiHelpers_createElement(Table, [(elements_5 = [(children = singleton(MuiHelpers_createElement(TableRow, [(elements = [header("", ctx.Locale.t("Customer.Customer")), header("Severity", ctx.Locale.t("Ticket.Severity.Severity")), header("TicketId", "#"), header("", ctx.Locale.t("Ticket.Status.Status"))], ["children", reactApi.Children.toArray(Array.from(elements))])])), MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray(Array.from(children))]])), (children_2 = toList(delay(() => {
        let children_1;
        return (tickets.length === 0) ? singleton_1((children_1 = singleton(MuiHelpers_createElement(TableCell, [["colSpan", 7], ["style", {
            textAlign: "center",
            fontStyle: "italic",
        }], ["size", "small"], ["children", ctx.Locale.t("OverviewDashboard.NoNonconformities")]])), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children_1))]]))) : singleton_1(map_1((ticket_1) => {
            let elements_3;
            let severityChip;
            const severity = Tickets_Severity_FromId_Z524259A4(ticket_1.Severity);
            severityChip = createElement(Tickets_SeverityChip_5E2CD6A8, {
                severity: severity,
            });
            let statusChip;
            const status_1 = Tickets_TicketStatus_FromId_Z524259A4(ticket_1.Status);
            statusChip = createElement(Tickets_StatusChip_Z17F2D702, {
                status: status_1,
                readOnly: true,
            });
            return MuiHelpers_createElement(TableRow, [["style", {
                cursor: "pointer",
            }], ["onClick", (_arg) => {
                RouterModule_nav(ofArray(["tickets", int32ToString(ticket_1.Id)]), 1, 1);
            }], ["hover", true], (elements_3 = [cell(ticket_1.Customer.Name), cell(severityChip), cell(MuiHelpers_createElement(Link, [["href", RouterModule_encodeParts(ofArray(["tickets", int32ToString(ticket_1.Id)]), 1)], ["children", ticket_1.Id]])), cell(statusChip)], ["children", reactApi.Children.toArray(Array.from(elements_3))])]);
        }, currentRows));
    })), MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(children_2))]]))], ["children", reactApi.Children.toArray(Array.from(elements_5))])])), MuiHelpers_createElement(TableContainer, [["children", reactApi.Children.toArray(Array.from(children_3))]])), MuiHelpers_createElement(TablePagination, [["component", "div"], ["count", sorted.length], ["page", page], ["rowsPerPage", rowsPerPage], ["rowsPerPageOptions", Array.from(rowsPerPageOptions)], ["onPageChange", ((arg10$0040, newPage) => {
        onPageChange(setPage, arg10$0040, newPage);
    })], ["onRowsPerPageChange", (ev) => {
        const newRowsPerPage = ev.target.value | 0;
        setPage(0);
        patternInput_5[1](newRowsPerPage);
    }]])];
    return react.createElement(react.Fragment, {}, ...xs_6);
}

